import * as constants from './constants'

export const getNews = (category, search, page) => ({
    type: constants.GET_NEWS,
    category,
    search,
    page,
})

export const setNews = (posts, paging) => ({
    type: constants.SET_NEWS,
    posts,
    paging,
})
